function PhoneNumberValidation(phoneNumber) {
  const phoneNumberFormat = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;
  return phoneNumberFormat.test(phoneNumber);
}

export function isValidPhoneNumber(value) {
  const numberFormatRegex = /^[0-9]{1,10}$/;
  return numberFormatRegex.test(value);
}

export default PhoneNumberValidation;
